import type { Section } from "@/data/pages";

export default function LegalSections({ sections }: { sections: Section[] }) {
  return (
    <div className="space-y-8">
      {sections.map((s) => (
        <section key={s.heading}>
          <h2 className="font-heading font-semibold text-lg text-foreground-950 mb-3">{s.heading}</h2>
          {s.paragraphs?.map((p) => (
            <p key={p} className="text-sm md:text-base text-foreground-700 leading-relaxed mb-3">
              {p}
            </p>
          ))}
          {s.bullets && (
            <ul className="space-y-1.5">
              {s.bullets.map((b) => (
                <li key={b} className="flex items-start gap-2 text-sm md:text-base text-foreground-700 leading-relaxed">
                  <span className="mt-2 w-1.5 h-1.5 shrink-0 rounded-full bg-primary-500"></span>
                  {b}
                </li>
              ))}
            </ul>
          )}
        </section>
      ))}
    </div>
  );
}
